import React, { useEffect, useState } from "react";
import { Modal, Checkbox, Row, Col } from 'antd';
const RoleSettingModal = ({ isOpen, onClose, onRoleChange, selectedRoles }) => {
    const [txtShowInformation, settxtShowInformation] = useState([]);
    useEffect(()=>{
        settxtShowInformation(selectedRoles);
    },[selectedRoles]);
    const onChange = (e) => {
        const { value, checked } = e.target;
        let updateRoles;
        if (checked) {
            updateRoles = [...txtShowInformation, value];
        } else {
            updateRoles = txtShowInformation.filter(item => item !== value)

        }
        settxtShowInformation(updateRoles);
        onRoleChange(updateRoles);
    };

    return (
        <Modal
            title="役割設定"
            visible={isOpen}
            onCancel={onClose}
            onOk={onClose}
            centered
        >
            <Row>
                <Col span={12}>
                    <Checkbox value="BussinessInformation" onChange={onChange} checked={txtShowInformation.includes("BussinessInformation")} >事業所情報</Checkbox>
                </Col>
                <Col span={12}>
                    <Checkbox value="DynamicReports" onChange={onChange} checked={txtShowInformation.includes("DynamicReports")}>動的レポート</Checkbox>
                </Col>
                <Col span={12}>
                    <Checkbox value="MaintenanceHistory" onChange={onChange} checked={txtShowInformation.includes("MaintenanceHistory")} >保全履歴</Checkbox>
                </Col>
                <Col span={12}>
                    <Checkbox value="InspectionHistory" onChange={onChange} checked={txtShowInformation.includes("InspectionHistory")}>点検履歴</Checkbox>
                </Col>
            </Row>
        </Modal>
    );
};
export default RoleSettingModal;